import { P01 } from "./SalesPerfSummary/P01";
import { P01_01 } from "./ActualLastYear/P01_01";
import { P01_02 } from "./ShareByRegion/P01_02";
import { P01_03 } from "./ShareByDistrict/P01_03";
import { P01_04 } from "./ActualTarget/P01_04";
import { P01_05 } from "./ProductSales/P01_05";

export const DistributorComparativeSalesPerf = {
  "sections": [
    P01,
    P01_02,
    P01_03,
    P01_04,
    P01_05,
    P01_01
  ]
}